import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const NavigationLayout = ({ children, title = "Msgg.me Toolbox" }) => {
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');
  const username = localStorage.getItem('username');
  const token = localStorage.getItem('authToken');

  const handleDropdownOpen = (event) => setAnchorElMenu(event.currentTarget);
  const handleDropdownClose = () => setAnchorElMenu(null);

  const handleMainMenu = () => {
    handleDropdownClose();
    navigate('/main');
  };

  const handleURLShortener = () => {
    handleDropdownClose();
    navigate('/urlshortener');
  };

  const handleAdminDashboard = () => {
    handleDropdownClose();
    navigate('/admin');
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handlePasswordResetSubmit = async () => {
    try {
      const response = await fetch('https://toolbox.msgg.me/api/users/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ currentPassword, newPassword })
      });

      const resData = await response.json();
      if (!response.ok) throw new Error(resData.message || 'Password reset failed');

      setSuccessMsg('Password changed successfully!');
      setOpenResetPasswordDialog(false);
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fff' }}>
      {/* Top Application Bar */}
      <AppBar position="static" sx={{ backgroundColor: 'yellow' }}>
        <Toolbar>
          <IconButton
            aria-label="menu"
            sx={{ color: 'black', mr: 2 }}
            onClick={handleDropdownOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, color: 'black' }}>
            {title} {username ? `(${username})` : ''}
          </Typography>
          <Menu
            anchorEl={anchorElMenu}
            open={Boolean(anchorElMenu)}
            onClose={handleDropdownClose}
            sx={{ mt: 2 }}
          >
            <MenuItem onClick={handleMainMenu}>SMS Logs Viewer</MenuItem>
            <MenuItem onClick={handleURLShortener}>URL Shortener</MenuItem>
            {userRole === 'ADMIN' && (
              <MenuItem onClick={handleAdminDashboard}>Admin Panel</MenuItem>
            )}
            <MenuItem onClick={() => { handleDropdownClose(); setOpenResetPasswordDialog(true); }}>
              Reset Password
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Main Page Content */}
      <Box sx={{ py: 2 }}>
        {error && <Alert severity="error" sx={{ mx: 3, mb: 2 }}>{error}</Alert>}
        {successMsg && <Alert severity="success" sx={{ mx: 3, mb: 2 }}>{successMsg}</Alert>}
        {children}
      </Box>

      {/* Password Reset Dialog */}
      <Dialog open={openResetPasswordDialog} onClose={() => setOpenResetPasswordDialog(false)}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Current Password"
            type="password"
            fullWidth
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <TextField
            margin="dense"
            label="New Password"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResetPasswordDialog(false)}>Cancel</Button>
          <Button onClick={handlePasswordResetSubmit} variant="contained">Update</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NavigationLayout;